import React, { useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { useCoursesUIContext } from "../CoursesUIContext";

const prepareFilter = (queryParams, values) => {
  const { name } = values;
  const parentId = queryParams.filter.parentId;
  const newQueryParams = { ...queryParams };
  const filter = { parentId, name };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function CoursesFilter() {
  // Courses UI Context
  const coursesUIContext = useCoursesUIContext();
  const coursesUIProps = useMemo(() => {
    return {
      setQueryParams: coursesUIContext.setQueryParams,
      queryParams: coursesUIContext.queryParams,
    };
  }, [coursesUIContext]);
  
  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(coursesUIProps.queryParams, values);
    if (!isEqual(newQueryParams, coursesUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      coursesUIProps.setQueryParams(newQueryParams);
    }
  };
  
  return (
    <Formik
      initialValues={{
        name: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}